import React from 'react'
import PropTypes from 'prop-types'

class MenuOverlay extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        className={`menu-overlay ${this.props.isVisible ? 'is-visible' : 'is-hidden'}`}
        onClick={this.props.onClick}
        style={{ zIndex: this.props.zIndex }}
      />
    )
  }
}

MenuOverlay.defaultProps = {
  isVisible: false,
  zIndex: 1000000,
}

MenuOverlay.propTypes = {
  isVisible: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  zIndex: PropTypes.number,
}

export default MenuOverlay
